import React from "react";

const ProfileDetails = ({ name, dateCreate, dateUpdate }) => {
  const formatDateString = (dtStr) => {
    if (!dtStr) return null;
    const date = new Date(dtStr);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const addLeadingZero = (num) => (num < 10 ? "0" + num : num);
    const time = `${((hours + 11) % 12) + 1}:${addLeadingZero(minutes)} ${
      hours < 12 ? "AM" : "PM"
    }`;
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const daySuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };
    return `${time}, ${day}${daySuffix(day)} ${month}`;
  };

  const createdFormatted = formatDateString(dateCreate);
  const updatedFormatted = formatDateString(dateUpdate);
  return (
    <div className="flex gap-5">
      {/* <Avatar
        className="w-8 h-8 lg:w-[60px] lg:h-[60px]"
        src="https://media.istockphoto.com/id/1476170969/photo/portrait-of-young-man-ready-for-job-business-concept.webp?b=1&s=612x612&w=0&k=20&c=A87DXDjXjoyJWkWIlLfhJYsjqKtTyuvhOg14QY4SeMQ="
      /> */}
      <div className="flex flex-col gap-2">
        <p className="text-[#454545] font-inter text-xl font-normal leading-normal max-[1056px]:text-xs">
          {name}
        </p>
        {/* <NavLink
          to=""
          className="text-[#1567A7] font-roboto text-base font-normal leading-normal max-[1056px]:text-xs"
        >
          View Profile
        </NavLink> */}
        {createdFormatted && (
          <p className="text-[#939393] font-inter text-base font-normal leading-normal max-[1056px]:text-[0.625rem]">
            Posted on: {createdFormatted}
            {updatedFormatted && (
              <>
                <br></br>
                Updated on: {updatedFormatted}
              </>
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProfileDetails;
